import { render, staticRenderFns } from "./TemplateDetailLanguageDialog.vue?vue&type=template&id=daf5f6ec"
import script from "./TemplateDetailLanguageDialog.vue?vue&type=script&lang=ts"
export * from "./TemplateDetailLanguageDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports